var _                      = require('underscore');
var $                      = require('jquery');
var Core                   = require('../core/core.js');

/**
 * Creates tray search filter
 *
 * @class
 */

class TraySearchFilter extends Core {

    _defaults() {
        return {
            fields: {
                'startingIndex': 0,
                'filterData': null,
                'filters': {},
                'htmlFilterList': {}
            }
        };
    }

    constructor(options) {

        super(options);

        this.template = `
            <div class="editor__tray__tabs__sub__searchfilter">

                <div class="editor__tray__tabs__sub__searchfilter__btn__remove">
                    <a class="js-tray__tabs__sub__searchfilter__btn__remove">
                        <%= embedded_svg("icon-cancel.svg") %>
                    </a>
                </div>

                 <select class="editor__tray__tabs__sub__searchfilter__filter__key">
                    <option value='' name='Select Filter'>Select Filter</option>
                    <% _.each(htmlFilterList, function(htmlFilter){ %>
                        <option value='<%- htmlFilter["serverName"] %>' name='<%- htmlFilter["displayTitle"] %>'><%- htmlFilter["displayTitle"] %></option>
                    <% }); %>
                </select>

                <div class="editor__tray__tabs__sub__searchfilter__input">
                </div>

                <div class="editor__tray__tabs__sub__searchfilter__btn__add">
                    <a class="js-tray__tabs__sub__searchfilter__btn__add">
                        <%= embedded_svg("icon-plus-small.svg") %>
                    </a>
                </div>

            </div>
        `;
     
        super.render();

        // used to know what type of input to create
        this.filters = options.fields["filters"];
        // used to turn the inputs red when setting shadows fails
        this.filterData = options.fields["filterData"];
        // used to know what filter is changing when sending data back
        this.index = options.fields["startingIndex"];
        // callback (set by function) that converts the units
        this._onBlur = null; 


        var self = this;
     
        $('.js-tray__tabs__sub__searchfilter__btn__add', this.$el).on('click', function(e){
            $(e.currentTarget).trigger('Cioui:TraySearchFilter:add', self.index);
        });

        $('.js-tray__tabs__sub__searchfilter__btn__remove', this.$el).on('click', function(e){
            $(e.currentTarget).trigger('Cioui:TraySearchFilter:remove', self.index);
        });

        $('.editor__tray__tabs__sub__searchfilter__filter__key', this.$el).on('input', function(e){
            var filter = self._filterchanged(e);
            self.removeInput(filter);
            self.addInput(filter);
        });


        this.$el.keypress(function(e) {
            if (e.which == 13) {
                self._enter(e);
            }
        });

        this.addInput(null);
    }

    _filterchanged(e){
        $(e.currentTarget).trigger('Cioui:TraySearchFilter:key', $(e.currentTarget).find('option:selected').attr("value"));
        //$(e.currentTarget).trigger('Cioui:TraySearchFilter:keyname', $(e.currentTarget).find('option:selected').attr("name"));
        return $(e.currentTarget).find('option:selected').attr("name");
    }
 
    _valchanged(e){
        $(e.currentTarget).trigger('Cioui:TraySearchFilter:val', $(e.currentTarget).val());
    }
 
    _enter(e){
        $(e.currentTarget).trigger('Cioui:TraySearchFilter:enter', $(e.currentTarget).val());
    }

    // this couples the view to the data.
    //   (makes sure what I see in text box is the same as in the interaction model)
    setValues(filterIM){
        $('.js-tray__tabs__sub__searchfilter__input__key', this.$el).val(filterIM.key()); 
        $('.js-tray__tabs__sub__searchfilter__input__value', this.$el).val(filterIM.val());
    }

    decreaseIndex(filterIM){
        this.index--;
        this.$el.trigger('Cioui:TraySearchFilter:index', this.index);

    }

    setOnBlur(f){
        this._onBlur = f;
    }

    addInput(name){
        var filter = this.getByTitle(name, this.filters);
        var self = this;
        
        // TODO this function sucks
        if(filter){
            if(!filter.enums){

                var temp = '<input class="js-tray__tabs__sub__searchfilter__input__value" type="text" placeholder="'+filter.defaultText+'"</input>';
                $('.editor__tray__tabs__sub__searchfilter__input', this.$el).append(temp);

                $('.js-tray__tabs__sub__searchfilter__input__value', this.$el).on('input', this._valchanged);
                $('.js-tray__tabs__sub__searchfilter__input__value', this.$el).on('blur', this._onBlur);

                this.filterData.valShadow.onSetFail(self, function () {
                    if(self.filterData.valShadow() !== null)
                        $('.js-tray__tabs__sub__searchfilter__input__value', self.$el).css("background", "#FF9999");
                }, 10);

                this.filterData.valShadow.onChange(self, function () {
                    $('.js-tray__tabs__sub__searchfilter__input__value', self.$el).css("background", "#FFFFFF");
                }, 9);
                
            } else {
                var temp = '<select class="js-tray__tabs__sub__searchfilter__input__enum">  <option value='+NaN+' name="Select One">Select One</option>';
   
                _.each(filter.enums, function(currEnum){ 
                    temp += '<option value='+currEnum.val+' name='+currEnum.key+'>'+currEnum.key+'</option>';
            
                });
                temp += '</select>';

                $('.editor__tray__tabs__sub__searchfilter__input', this.$el).append(temp);
                $('.js-tray__tabs__sub__searchfilter__input__enum', this.$el).on('input', this._valchanged);
            }

            var temp = '<div class="editor__tray__tabs__sub__searchfilter__description"> '+ filter.description + '</div>';
            $('.editor__tray__tabs__sub__searchfilter__input', this.$el).append(temp);
        }
    }

    getByTitle(title){
        for(var key in this.filters){
            if(this.filters.hasOwnProperty(key) && this.filters[key].displayTitle && this.filters[key].displayTitle == title){
                return this.filters[key];
            }
        }
        return null;
    }

    removeInput(){
        $('.js-tray__tabs__sub__searchfilter__input__value', this.$el).remove();
        $('.js-tray__tabs__sub__searchfilter__input__enum', this.$el).remove();
        $('.editor__tray__tabs__sub__searchfilter__description', this.$el).remove();
    }
}

module.exports = TraySearchFilter;
